module.exports = __webpack_public_path__ + "img/xiz.47797bed.png";